import { EntityModel } from '@/interfaces'
import {
  ALL_AGE_GROUP_CAPACITIES_QUERY,
  CREATE_AGE_GROUP_CAPACITY_MUTATION,
  DELETE_AGE_GROUP_CAPACITY_MUTATION,
  FORCE_DELETE_AGE_GROUP_CAPACITY_MUTATION,
  SINGLE_AGE_GROUP_CAPACITY_QUERY,
  UPDATE_AGE_GROUP_CAPACITY_MUTATION,
} from './graphql'
import travelPricingAgeGroupEntity from '@/entities/travelPricingAgeGroup/entity'

const accommodationAgeGroupCapacityModel: EntityModel = {
  name: 'ageGroupCapacity',
  namePlural: 'ageGroupCapacities',
  uniqueName: 'accommodationAgeGroupCapacity',
  uniqueNamePlural: 'accommodationAgeGroupCapacities',
  path: 'travel/pricing/accommodation/age_group_capacity',
  baseUrl: '/travel/pricing/accommodation/age_group_capacities',
  translationPrefix: 'entities:accommodationAgeGroupCapacity.',
  getDisplayName: (values: any) => {
    return 'Age Group Capacity'
  },
  gql: {
    getAll: ALL_AGE_GROUP_CAPACITIES_QUERY,
    getSingle: SINGLE_AGE_GROUP_CAPACITY_QUERY,
    create: CREATE_AGE_GROUP_CAPACITY_MUTATION,
    update: UPDATE_AGE_GROUP_CAPACITY_MUTATION,
    delete: DELETE_AGE_GROUP_CAPACITY_MUTATION,
    forceDelete: FORCE_DELETE_AGE_GROUP_CAPACITY_MUTATION,
  },
  attributes: {
    ageGroup: {
      name: 'ageGroup',
      label: 'entities:accommodationAgeGroupCapacity.attributes.ageGroup.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelPricingAgeGroupEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    minCapacity: {
      name: 'minCapacity',
      label: 'entities:accommodationAgeGroupCapacity.attributes.minCapacity.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'number',
        },
      ],
    },
    maxCapacity: {
      name: 'maxCapacity',
      label: 'entities:accommodationAgeGroupCapacity.attributes.maxCapacity.label',
      type: 'value',
      dataType: 'number',
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'number',
        },
      ],
    },
  },
}

export default accommodationAgeGroupCapacityModel
